import React, { Component } from "react";

import { t } from "app/utils";

class FreeTextItem extends Component {
  static defaultProps = {
    onChange: () => {},
    submittedResponse: { body: "" }
  };

  constructor(props) {
    super(props);

    this.state = { body: props.submittedResponse.body };
  }

  handleChange = ({ target: { value: body } }) => {
    const { onChange, surveyItem } = this.props;

    this.setState({ body });
    onChange({ surveyItemId: surveyItem.id, body });
  };

  render() {
    const { body } = this.state;

    return (
      <div className="SurveyItemFreeText">
        <form onSubmit={event => event.preventDefault()}>
          <div className="form-group">
            <input
              className="input form-control"
              type="text"
              value={body}
              placeholder={t("Type your response here...")}
              onChange={this.handleChange}
            />
          </div>
        </form>
      </div>
    );
  }
}

export default FreeTextItem;
